import React, { useEffect } from 'react';
import './AboutusHome.css';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import collab from '../Images/Aboutus.webp';
import teams11 from '../Images/OurMission.webp';
import teams1 from '../Images/services.webp';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

const AboutusHome = () => {

  useEffect(() => {
    // Scroll to the top when the page is loaded
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar/>
      <div className="aboutushome-page">
        <div className="aboutus-home">
          
          {/* First Section - Left Image, Right Text */}
          <div className="aboutus-section">
            <div className="aboutus-section-left">
              <img src={collab} alt="About Us" className="aboutus-image" />
            </div>
            <div className="aboutus-section-right">
              <h2>About Us</h2>
              <p>
                At <strong>Litax</strong>, we believe taxes shouldn’t be a burden—they should be an 
                opportunity to plan smarter, save better, and secure your financial future. Established 
                with the vision of transforming how individuals and businesses approach taxation, we bring 
                together deep expertise, modern technology, and a client-first mindset. Over the years, 
                we’ve partnered with professionals, entrepreneurs, small businesses, and corporations, 
                offering not just services, but peace of mind.  
              </p>
              <p>
                Our team is made up of highly skilled professionals who combine technical know-how 
                with practical insights to deliver solutions that are accurate, transparent, and 
                easy to understand. Whether you are an individual trying to maximize your savings, 
                a startup managing compliance, or a business navigating complex tax landscapes, 
                Litax is here to simplify the process and empower your decisions.
              </p>
            </div>
          </div>

          {/* Second Section - Right Text, Left Image */}
          <div className="aboutus-section-middle">
            <div className="aboutus-section-right-middle">
              <h2>Our Mission</h2>
              <p>
                Our mission is simple yet powerful: to help clients achieve financial clarity and 
                confidence through reliable tax planning and advisory. Taxes can often feel overwhelming, 
                with ever-changing laws and endless paperwork. That’s why we dedicate ourselves to 
                staying ahead of regulations, interpreting complex rules, and transforming them into 
                practical strategies that work for you.  
              </p>
              <p>
                At Litax, we don’t just file returns—we provide long-term guidance. We 
                believe in building lasting relationships where our clients feel supported year-round, 
                not just during tax season. By combining data-driven analysis with a personal touch, 
                we ensure every strategy aligns with your unique goals—whether it’s protecting your 
                hard-earned income, minimizing liabilities, or planning for growth. Our mission goes 
                beyond compliance—it’s about creating financial stability and opportunities for the 
                people we serve.
              </p>
            </div>
            <div className="aboutus-section-left-middle">
              <img src={teams11} alt="Our Mission" className="aboutus-image-middle" />
            </div>
          </div>

          {/* Third Section - Left Image, Right Text */}
          <div className="aboutus-section">
            <div className="aboutus-section-left">
              <img src={teams1} alt="Our Services" className="aboutus-image" />
            </div>
            <div className="aboutus-section-right">
              <h2>Our Services</h2>
              <p>
                We provide a complete range of tax and financial services designed to meet the 
                needs of today’s fast-paced world. From simple individual tax filings to 
                complex business returns, our offerings cover every stage of your financial journey.  
              </p>
              <p>
                <ul>
                  <li><strong>Individual & Business Tax Preparation:</strong> Accurate, compliant, and optimized filings tailored to your circumstances.</li>
                  <li><strong>IRS Representation:</strong> Professional support when dealing with audits, notices, or disputes, ensuring your rights are protected.</li>
                  <li><strong>Tax Consulting:</strong> Strategic advice to help you minimize liabilities, claim deductions, and plan effectively for the future.</li>
                  <li><strong>Retirement & Wealth Planning:</strong> Guidance to secure your long-term financial stability and maximize post-retirement benefits.</li>
                </ul>
              </p>
              <p>
                What sets us apart is our commitment to combining professionalism with 
                accessibility. We break down complex regulations into simple, actionable 
                steps that our clients can easily understand and follow. With Litax, 
                you don’t just get a service provider—you get a dedicated financial partner 
                invested in your success. 
              </p>
            </div>
          </div>

        </div>
      </div>
      <Cosection/>
      <Whatsapp/>
      <ScrollTop/>
      <Footer/>
    </div>
  );
};

export default AboutusHome;
